<template>
  <div class="h-full ">
    <div class="contnet ">
      <PrtMap class="border" :items="items" v-if="items" />
    </div>
  </div>
</template>

<script>
import PrtMap from '@/components/organisms/PrtMap/PrtMap.vue'
export default {
  name: 'Home',
  components: { PrtMap },
  mounted() {
    this.listenForItems()
  },

  data: () => ({
    items: [],
    title: '',
    content: '',
    index: 0,

    isLoading: true,
    isPopupOpened: false
  }),

  methods: {
    listenForItems() {
      this.$root.$on('itemsPL', items => {
        this.items = items
        console.log('ttt', this.items)
        this.$forceUpdate()
      })
    }
  }
}
</script>

<style lang="scss">
.prt-map {
  height: 500px;
}
</style>
